import Vue from 'vue'
import axios from 'axios'

const baseURL = process.env.VUE_APP_API_BASE_URL

const axiosIns = axios.create({
  baseURL,
  headers: { 'X-Custom-Header': 'foobar', 'Content-Type': 'application/json' },
})

axiosIns.interceptors.request.use(config => {
  const accessToken = localStorage.getItem('accessToken')

  if (accessToken && config.authRequired !== false) {
    config.headers.Authorization = `Bearer ${accessToken}`
  }

  return config
})

axiosIns.interceptors.response.use(
  response => response,
  error => {
    const originalRequest = error.config
    const refreshToken = localStorage.getItem('refreshToken')

    if (error.response?.status === 403 && refreshToken && !originalRequest._retry) {
      originalRequest._retry = true

      return axiosIns
        .post('/auth/refreshToken', { refreshToken })
        .then(response => {
          const newAccessToken = response.data.accessToken

          localStorage.setItem('accessToken', newAccessToken)

          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`

          return axiosIns(originalRequest)
        })
    }

    return Promise.reject(error)
  },
)

Vue.prototype.$http = axiosIns

export default axiosIns
